<ng-container *ngTemplateOutlet="displayInvalidResidenceScreen ? invalidResidenceScreen : residenceScreen" />
<ng-template #residenceScreen>
  <onboarding-container
    [formValid]="isFormValid$ | async"
    [loading]="facade.sendingResidenceInformation$ | async"
    (back)="facade.goToPreviousStep()"
    (forward)="submit()"
  >
    <p class="zero-text p-huge-med">{{ 'onboarding.residence.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'onboarding.residence.text' | transloco }}</p>
    <web-design-system-select
      [items]="countries$ | async"
      [placeholder]="'onboarding.residence.residence-label' | transloco"
      (selectItem)="selectResidence($event)"
    />
    <div ngbDropdown>
      <web-design-system-input
        ngbDropdownToggle
        class="d-block mt-4"
        [icon]="'magnifier'"
        [label]="'onboarding.residence.address-label' | transloco"
        [value]="searchTerm$ | async"
        [autocomplete]="false"
        (valueChange)="handleSearchTermChange($event)"
      />
      <div ngbDropdownMenu>
        <div class="suggestion" ngbDropdownItem (click)="useAdress(null, addressModal)" (keyup.Enter)="useAdress(null, addressModal)">
          <div class="d-flex gap-small">
            <div class="zero-text p-base-reg">{{ 'onboarding.residence.no-addresses-found' | transloco }}</div>
            <div class="zero-text p-base-reg link">{{ 'onboarding.residence.no-addresses-found-link' | transloco }}</div>
          </div>
        </div>
        @if (addressSuggestions$ | async; as suggestions) {
          @for (suggestion of suggestions; track $index; let isLast = $last) {
            <div
              class="suggestion"
              [class.last]="isLast"
              ngbDropdownItem
              (click)="useAdress(suggestion, addressModal)"
              (keyup.Enter)="useAdress(suggestion, addressModal)"
            >
              @if (suggestion?.street) {
                <div class="zero-text p-base-reg">
                  {{ suggestion.street }}{{ suggestion.streetNumber ? ', ' + suggestion.streetNumber : '' }}
                </div>
              }
              @if (suggestion?.city) {
                <div class="zero-text p-base-reg">{{ suggestion.city }}{{ suggestion.zip ? ', ' + suggestion.zip : '' }}</div>
              }
            </div>
          }
        }
      </div>
    </div>
  </onboarding-container>
</ng-template>

<ng-template #invalidResidenceScreen>
  <onboarding-container [hideForward]="true" [hideBack]="true">
    <p class="zero-text p-huge-med">{{ 'onboarding.residence.invalid-residence.headline' | transloco }}</p>
    <p class="zero-text p-base-reg">{{ 'onboarding.residence.invalid-residence.text' | transloco }}</p>

    <div class="mt-5">
      @if (facade.deletedAllDataSuccessfully$ | async) {
        <div class="zero-text course-green d-flex justify-content-end mb-2">
          {{ 'onboarding.residence.invalid-residence.success' | transloco }}
        </div>
      }
      <div class="d-flex justify-content-end">
        <web-design-system-button
          [disabled]="(facade.deletingAllData$ | async) || (facade.deletedAllDataSuccessfully$ | async)"
          (click)="facade.deleteAllData()"
        >
          {{ 'onboarding.residence.invalid-residence.btn' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  </onboarding-container>
</ng-template>

<ng-template #addressModal let-modal>
  <web-design-system-modal [headline]="'onboarding.residence.modal.headline' | transloco" (dismiss)="dismissModal(modal)">
    <div class="row">
      <div class="col-12 col-sm-8">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'onboarding.residence.modal.street' | transloco"
          [value]="street$ | async"
          [autocomplete]="false"
          (valueChange)="handleStreetChange($event)"
        />
      </div>
      <div class="col-12 col-sm-4">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'onboarding.residence.modal.streetNumber' | transloco"
          [value]="streetNumber$ | async"
          [autocomplete]="false"
          (valueChange)="handleStreetNumberChange($event)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'onboarding.residence.modal.addition' | transloco"
          [value]="addition$ | async"
          [autocomplete]="false"
          (valueChange)="handleAdditionChange($event)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'onboarding.residence.modal.zip' | transloco"
          [value]="zip$ | async"
          [autocomplete]="false"
          (valueChange)="handleZipChange($event)"
        />
      </div>
      <div class="col-12 col-sm-8">
        <web-design-system-input
          class="d-block mt-4"
          [label]="'onboarding.residence.modal.city' | transloco"
          [value]="city$ | async"
          [autocomplete]="false"
          (valueChange)="handleCityChange($event)"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <web-design-system-button class="mt-4" (click)="dismissModal(modal); submit()" [disabled]="(isFormValid$ | async) === false">
        {{ 'onboarding.residence.modal.btn' | transloco }}
      </web-design-system-button>
    </div>
  </web-design-system-modal>
</ng-template>
